import { useState } from "react";
import Loading from "components/Loading";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { getProductDetail, addSystems } from "actions/spyAdvancedActions";
import useCallApi from "hook/useCallApi";
import ModalCreate from "../../modal/modalCreate";
import ProductSlider from "./slider";
import ProductInfo from "./info";
import ProductDashboard from "./dashboard";
import InfluencerList from "./table/InfluencersList";
import VideoList from "./table/VideosList";
import LiveList from "./table/liveList";

const ProductDetail = ({ getProductDetail, addSystems }) => {
    const { id } = useParams();
    const { data: product, loading } = useCallApi(getProductDetail, id);
    const [openCreate, setOpenCreate] = useState(false);

    const [saveLoading, setSaveLoading] = useState(false);

    if (!product && loading) return <Loading isLoading={true} />;
    if (!product) return;

    const handleSave = async (data) => {
        setSaveLoading(true);
        await addSystems({ ...data, productId: product?.product_id });
        setSaveLoading(false);
    };

    return (
        <div style={{ maxWidth: "1580px", margin: "auto" }}>
            <div className="card mb-5 mb-xl-10">
                <Loading isLoading={loading || saveLoading} />
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-3 text-center">
                            {Boolean(product?.images?.length) && <ProductSlider images={product?.images} />}
                        </div>

                        <ProductInfo product={product} />

                        <div className="col-md-5">
                            <div className="d-flex align-items-end flex-column w-100 mb-4">
                                <div>
                                    <button
                                        data-tooltip-id="my-tooltip"
                                        data-tooltip-content={"Add To System"}
                                        onClick={() => setOpenCreate(true)}
                                        className="btn btn-info mb-4"
                                    >
                                        <i className="fas fa-plus px-0" />
                                    </button>
                                </div>
                                <span className="text-danger text-right">Recently update: {product.update_time}</span>
                            </div>
                            <div className="mb-8 d-flex gap-4">
                                {[
                                    { label: "Total Sales", value: product?.sale_cnt, icon: "ki-outline ki-like" },
                                    { label: "GMV", value: product?.gmv_amt, icon: "ki-outline ki-wallet" },
                                    {
                                        label: "Total Influencers",
                                        value: product?.total_ifl_cnt,
                                        icon: "ki-outline ki-award",
                                    },
                                    {
                                        label: "Total Videos",
                                        value: product?.total_video_cnt,
                                        icon: "ki-outline ki-to-right",
                                    },
                                    {
                                        label: "Total lives",
                                        value: product?.total_live_cnt,
                                        icon: "ki-outline ki-wifi-home",
                                    },
                                ].map((item, key) => (
                                    <div
                                        className="bg-light-info al-border-radius-8 py-8 px-4 d-flex flex-column justify-content-center align-items-center text-center"
                                        style={{ flex: "1 1 20%" }}
                                        key={key}
                                    >
                                        <i className={`${item.icon} fs-4 text-info my-4`}></i>
                                        <p className="mb-0 fw-bold fs-2">{item.value}</p>
                                        <label className="fw-semibold text-gray-500">{item.label}</label>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ProductDashboard product={product} />
            <InfluencerList />
            <VideoList />
            <LiveList />
            <ModalCreate
                isOpen={openCreate}
                onClose={() => setOpenCreate(false)}
                product={product}
                onSubmit={handleSave}
            />
        </div>
    );
};

export default connect(null, { getProductDetail, addSystems })(ProductDetail);
